<template>
  <div>
    <v-btn
      @click="$emit('onsearch')"
      depressed
      color="grey lighten-3"
      style="border-radius: 0; min-width: 100%; height: 45px"
      class="ma-0 pa-0"
    >
      <span> <v-icon small>search</v-icon> {{ $t('Search') }} </span>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      searchlist: 'getLivechatSearching'
    })
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatSearchBox.vue